export default "__VITE_ASSET__DId083nL__"